import { render } from "./ControllingPersonLegalEntities.vue?vue&type=template&id=61ada273&scoped=true"
import script from "./ControllingPersonLegalEntities.vue?vue&type=script&lang=js"
export * from "./ControllingPersonLegalEntities.vue?vue&type=script&lang=js"

import "./ControllingPersonLegalEntities.vue?vue&type=style&index=0&id=61ada273&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61ada273"]])

export default __exports__